module.exports = {"attributes":{"viewBox":"0 0 12 14"},"content":"<path fill-rule=\"evenodd\" d=\"M3.8 7.6L.4 3.2A2 2 0 0 1 2 0h7.7a2 2 0 0 1 1.6 3.2L7.8 7.6v3.7c0 .4-.2.7-.5 1l-2 1a1 1 0 0 1-1.5-1V7.6z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-filter.svg
// module id = 1285
// module chunks = 0